import { useEffect, useState } from "react";
import { styled } from "styled-components";
import { Colors, DeathMessages } from "../constants";
import Headline from "./Headline";
import CharacterSheet from "./CharacterSheet";
import Loading from "./Loading";
import Characters from "../characters";
import { motion } from "framer-motion";
import PrimaryNavBar from "./PrimaryNavBar";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  background: ${Colors.Red};
`;

const NavRow = styled.div`
  display: flex;
  flex-direction: horizontal;
  min-height: 48px;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1024px;
`;

const NewCharacterButton = styled(motion.div)`
  font-size: 14px;
  line-height: 100%;
  height: 48px;
  min-height: 48px;
  color: ${Colors.RedDark};
  font-family: "Space Grotesk", sans-serif;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
  padding: 0 48px;
`;

const BackButton = styled(NewCharacterButton)``;

const Generator = styled.div`
  width: 100%;
  height: 100%;
  background: Colors.Red;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  user-select: none;
  @media (max-width: 800px) {
    height: auto;
  }
`;

const CharacterGenerator = ({ roll, rollDie }) => {
  const [character, setCharacter] = useState(null);
  const [newCharacterMessage, setNewCharacterMessage] = useState(
    "Get a new character"
  );
  const [currentTab, setCurrentTab] = useState("actions");

  const getCharacter = (rawCharacter) => {
    let newCharacter = JSON.parse(JSON.stringify(rawCharacter));
    let bonuses = {};
    for (let stat in newCharacter.stats) {
      bonuses[stat] = newCharacter.stats[stat];
      for (let item in newCharacter.items) {
        if (newCharacter.items[item].stat === stat) {
          bonuses[stat] = bonuses[stat] + newCharacter.items[item].bonus;
        }
      }
    }
    newCharacter.bonuses = bonuses;
    setCharacter(newCharacter);
  };

  const newCharacter = () => {
    const randomCharacter =
      Characters[Math.floor(Math.random() * Characters.length)];
    getCharacter(randomCharacter);
    const randomMessage =
      DeathMessages[Math.floor(Math.random() * DeathMessages.length)];
    setNewCharacterMessage(randomMessage);
  };

  useEffect(() => {
    if (Characters && character === null) {
      const randomCharacter =
        Characters[Math.floor(Math.random() * Characters.length)];
      getCharacter(randomCharacter);
    }
  });

  return (
    <Wrapper>
      <Generator>
        {character === null ? (
          <Loading />
        ) : (
          <>
            <NavRow>
              <BackButton
                initial={{ scale: 1, color: Colors.Tan }}
                whileHover={{ scale: 1.05, color: Colors.Tan }}
                whileTap={{ scale: 0.95, color: Colors.Tan }}
                transition={{ type: "ease-out", duration: 0.25 }}
                onClick={() => window.location.reload()}
              >
                Back
              </BackButton>
              <NewCharacterButton
                initial={{ scale: 1, color: Colors.Tan }}
                whileHover={{ scale: 1.05, color: Colors.Tan }}
                whileTap={{ scale: 0.95, color: Colors.Tan }}
                transition={{ type: "ease-out", duration: 0.25 }}
                onClick={() => newCharacter()}
              >
                Get a new character
              </NewCharacterButton>
            </NavRow>
            <Headline
              title={character.name}
              character={character}
              roll={roll}
            />
            <CharacterSheet
              character={character}
              rollDie={rollDie}
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
            />
          </>
        )}
      </Generator>
    </Wrapper>
  );
};

export default CharacterGenerator;
